import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-white">
      <div className="relative w-20 h-20">
        <div
          className="absolute inset-0 rounded-full border-4 border-gray-300 border-t-transparent animate-spin"
        ></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
